import yup from 'config/yup';

export default yup.object().shape({
  option_id: yup.number().required(),
});
